import React, { Component } from 'react';

import './CompetitorsList.css';

/**
 * Modules
 */
import { Select, Input, List, Avatar, Form, Modal } from 'antd';
import { getCompetitorsFromChamp, getTeamsFromCompetitors } from '../../../utils/competitorsFunctions';
import RegistrationForm from '../registrationForm/RegistrationForm';

import { getAuth, onAuthStateChanged } from 'firebase/auth';

class CompetitorsList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            champKey: this.props.champId,
            arrayOfTeams: [],
            arrayOfCompetitors: [],
            arrayOfCompetitorsFiltered: [],

            filterFaixa: '',
            filterPeso: '',
            filterIdade: '',
            filterEquipe: '',

            loading: true,

            competitorModal: false,
        }
    }

    componentDidMount = () => {
        this.getAllCompetitors(this.props.champId);
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.competitorsList && (prevProps.competitorsList.length !== this.props.competitorsList.length))
            this.getAllCompetitors(this.props.champId);
    }

    getAllCompetitors = async (key) => {
        this.setState({
            arrayOfCompetitorsFiltered: [],
            loading: true
        })

        // Get all competitors
        let competitorsArray = this.props.competitorsList
        if (!competitorsArray) competitorsArray = await getCompetitorsFromChamp(key);

        // Get all teams
        let teams = await getTeamsFromCompetitors(competitorsArray);

        this.setState({
            arrayOfCompetitors: competitorsArray,
            arrayOfCompetitorsFiltered: competitorsArray,
            arrayOfTeams: teams,
            loading: false
        });
    }

    /**
     * Methods to read student
     */
    searchStudent = (value) => {
        let localFilteredArray = this.state.arrayOfCompetitors

        /* Create array with the final result and a flag to know when another filter has alread choosed */
        let finalLocalArray = [], hasAnotherFilter = false

        /* Check if a filter of name was determined */
        if (value) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of faixa was determined */
        if (this.state.filterFaixa) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['faixa'] === this.state.filterFaixa)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['faixa'] === this.state.filterFaixa)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of peso was determined */
        if (this.state.filterPeso) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['peso'] === this.state.filterPeso)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['peso'] === this.state.filterPeso)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of idade was determined */
        if (this.state.filterIdade) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['idade'] === this.state.filterIdade)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['idade'] === this.state.filterIdade)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of equipe was determined */
        if (this.state.filterEquipe) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['equipe'] === this.state.filterEquipe)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['equipe'] === this.state.filterEquipe)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if hasn't filter was select */
        if (!this.state.filterFaixa && !this.state.filterPeso && !this.state.filterIdade && !this.state.filterEquipe && !value) {
            finalLocalArray = localFilteredArray
        }

        this.setState({
            arrayOfCompetitorsFiltered: finalLocalArray,
            loading: false
        })

    }

    filterFaixa = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterFaixa: value
                })
            )
        })
            .then(() => {
                this.searchStudent(this.props.form.getFieldValue('name'))
            })
    }

    filterPeso = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterPeso: value
                })
            )
        })
            .then(() => {
                this.searchStudent(this.props.form.getFieldValue('name'))
            })
    }

    filterIdade = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterIdade: value
                })
            )
        })
            .then(() => {
                this.searchStudent(this.props.form.getFieldValue('name'))
            })
    }

    filterEquipe = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterEquipe: value
                })
            )
        })
            .then(() => {
                this.searchStudent(this.props.form.getFieldValue('name'))
            })
    }

    /* Methods to open competitor modal and edit or delete this competitor */
    openCompetitorModal = async (competitor) => {
        const auth = await getAuth();
        await onAuthStateChanged(auth, user => {
            if (user) {
                this.setState({
                    competitorModal: true,
                    competitorToUpdate: competitor
                })
            }
        })
    }

    closeCompetitorModal = () => {
        this.setState({ competitorModal: false })
        if (this.props.closeUpdateModal)
            this.props.closeUpdateModal()
    }

    render() {

        const { getFieldDecorator } = this.props.form

        return (
            <div>
                <Form>
                    <Form.Item style={{ width: '49%', marginRight: '2%', marginBottom: '5px', float: 'left' }}>
                        {getFieldDecorator('faixa')(
                            <Select
                                showSearch
                                placeholder="Filtrar faixa"
                                optionFilterProp="children"
                                onChange={this.filterFaixa}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className='sharedInput'
                            >
                                <Select.Option value={null}>Todas</Select.Option>
                                <Select.Option value="whiteSmoke">Branca</Select.Option>
                                <Select.Option value="grey">Cinza</Select.Option>
                                <Select.Option value="yellow">Amarela</Select.Option>
                                <Select.Option value="orange">Laranja</Select.Option>
                                <Select.Option value="green">Verde</Select.Option>
                                <Select.Option value="#ffcc99">Colorido</Select.Option>
                                <Select.Option value="blue">Azul</Select.Option>
                                <Select.Option value="purple">Roxa</Select.Option>
                                <Select.Option value="brown">Marrom</Select.Option>
                                <Select.Option value="black">Preta</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', float: 'left', marginBottom: '5px' }}>
                        {getFieldDecorator('peso')(
                            <Select
                                showSearch
                                placeholder="Filtrar peso"
                                optionFilterProp="children"
                                onChange={this.filterPeso}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className='sharedInput'
                            >
                                <Select.Option value={null}>Todos</Select.Option>
                                <Select.Option value="Galo">Galo</Select.Option>
                                <Select.Option value="Pluma">Pluma</Select.Option>
                                <Select.Option value="Pena">Pena</Select.Option>
                                <Select.Option value="Leve">Leve</Select.Option>
                                <Select.Option value="Médio">Médio</Select.Option>
                                <Select.Option value="Meio Pesado">Meio Pesado</Select.Option>
                                <Select.Option value="Pesado">Pesado</Select.Option>
                                <Select.Option value="Super Pesado">Super Pesado</Select.Option>
                                <Select.Option value="Pesadíssimo">Pesadíssimo</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginRight: '2%', marginBottom: '5px', float: 'left' }}>
                        {getFieldDecorator('idade')(
                            <Select
                                showSearch
                                placeholder="Filtrar idade"
                                optionFilterProp="children"
                                onChange={this.filterIdade}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className='sharedInput'
                            >
                                <Select.Option value={null}>Todas</Select.Option>
                                <Select.Option value="Pré-Mirim">Pré-Mirim</Select.Option>
                                <Select.Option value="Mirim 1">Mirim 1</Select.Option>
                                <Select.Option value="Mirim 2">Mirim 2</Select.Option>
                                <Select.Option value="Infantil 1">Infantil 1</Select.Option>
                                <Select.Option value="Infantil 2">Infantil 2</Select.Option>
                                <Select.Option value="Infanto 1">Infanto 1</Select.Option>
                                <Select.Option value="Infanto 2">Infanto 2</Select.Option>
                                {/*
                                <Select.Option value="Mirim">Mirim</Select.Option>
                                <Select.Option value="Infantil">Infantil</Select.Option>
                                <Select.Option value="Infanto">Infanto</Select.Option>
                                */}
                                <Select.Option value="Juvenil">Juvenil</Select.Option>
                                <Select.Option value="Adulto">Adulto</Select.Option>
                                <Select.Option value="Master 1">Master 1</Select.Option>
                                <Select.Option value="Master 2">Master 2</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', float: 'left', marginBottom: '5px' }}>
                        {getFieldDecorator('equipe')(
                            <Select
                                showSearch
                                placeholder="Filtrar equipe"
                                optionFilterProp="children"
                                onChange={this.filterEquipe}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className='sharedInput'
                            >
                                <Select.Option value={null}>Todas</Select.Option>
                                {
                                    this.state.arrayOfTeams.map(team => {
                                        return (
                                            <Select.Option key={team} value={team}>{team}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '100%', marginBottom: '15px', float: 'left' }}>
                        {getFieldDecorator('name')(
                            <Input placeholder="Buscar aluno" id='searchInput' onChange={e => this.searchStudent(e.target.value)} className='sharedInput browser-default' />
                        )}
                    </Form.Item>
                </Form>
                <div style={{ clear: 'both' }}></div>

                <List
                    locale={{ emptyText: 'Nenhum aluno/competidor encontrado' }}
                    className="demo-loadmore-list"
                    itemLayout="horizontal"
                    dataSource={this.state.arrayOfCompetitorsFiltered}
                    loading={this.state.loading}
                    renderItem={competitor => (
                        <List.Item style={{ cursor: 'pointer' }} onClick={() => this.openCompetitorModal(competitor)}>
                            <List.Item.Meta
                                style={{ fontSize: 'x-small' }}
                                avatar={<Avatar size='small' style={{ backgroundColor: competitor.faixa }} />}
                                title={competitor.nome}
                                description={competitor.peso + ' | ' + competitor.idade + ' | ' + competitor.equipe}
                            />
                            <div>
                                {competitor.confirmedPayment === false ? 'Aguardando confirmação de pagamento' : null}
                            </div>
                        </List.Item>
                    )}
                />

                <Modal
                    title='Informações do competidor'
                    visible={this.state.competitorModal}
                    onCancel={this.closeCompetitorModal}
                    footer={[
                        // <Button key='cancel' onClick={this.closeCompetitorModal}>Fechar</Button>
                    ]}
                >
                    <RegistrationForm
                        arrayOfTeams={this.state.arrayOfTeams}
                        champInfo={this.props.champ}
                        champId={this.props.champId}
                        quadroDePesos={this.state.quadroDePesos}
                        competitorToUpdate={this.state.competitorToUpdate}
                        closeModal={this.closeCompetitorModal}
                        updateStudentList={() => {
                            this.closeCompetitorModal();
                            this.getAllCompetitors(this.props.champId);
                        }}
                    />
                </Modal>
            </div>
        )
    }

}

export default Form.create()(CompetitorsList)